/**
 * Service centralisé pour les appels API avec authentification JWT.
 * Stocke le JWT en mémoire (et localStorage comme fallback) et l'envoie
 * automatiquement en header Authorization: Bearer sur chaque requête.
 */

const JWT_STORAGE_KEY = 'nomade_jwt';

let _jwtToken = null;

/**
 * Stocke le JWT reçu après authentification SAML.
 * @param {string} token
 */
export const setJwt = (token) => {
    _jwtToken = token;
    if (token) {
        localStorage.setItem(JWT_STORAGE_KEY, token);
    } else {
        localStorage.removeItem(JWT_STORAGE_KEY);
    }
};

/**
 * Retourne le JWT courant (mémoire ou localStorage).
 * @returns {string|null}
 */
export const getJwt = () => {
    if (_jwtToken) return _jwtToken;
    const stored = localStorage.getItem(JWT_STORAGE_KEY);
    if (stored) {
        _jwtToken = stored;
        return _jwtToken;
    }
    return null;
};

/**
 * Supprime le JWT (déconnexion).
 */
export const clearJwt = () => {
    _jwtToken = null;
    localStorage.removeItem(JWT_STORAGE_KEY);
};

/**
 * Effectue un fetch avec le header Authorization: Bearer <jwt> automatiquement ajouté.
 * Remplace les appels directs à fetch() dans les services.
 *
 * @param {string} url
 * @param {RequestInit} options
 * @returns {Promise<Response>}
 */
export const apiFetch = async (url, options = {}) => {
    const token = getJwt();
    const headers = {
        ...(options.headers || {}),
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return fetch(url, {
        ...options,
        headers,
    });
};
